import { useCallback } from "react";
import { parsePath, type To } from "history";
import { useLocation } from "react-router";

import { keepSearchParams } from "./keepSearchParams";

export const useMiddleware = () => {
  const from = useLocation();

  return useCallback(
    (to: To) => {
      const toPartialPath = typeof to === "string" ? parsePath(to) : to;
      const toSearchParams = new URLSearchParams(toPartialPath.search);
      const fromSearchParams = new URLSearchParams(from.search);

      keepSearchParams.forEach((param) => {
        const toParam = toSearchParams.get(param);
        const fromParam = fromSearchParams.get(param);
        if (!toParam && fromParam) {
          toSearchParams.set(param, fromParam);
        }
      });

      const toSearch = toSearchParams.toString();

      return {
        ...toPartialPath,
        search: toSearch ? `?${toSearch}` : undefined,
      };
    },
    [from],
  );
};
